import type { Router } from 'vue-router';
import store from '../store/store';
import userClient from '../api/user-service';
import { LOGOUT, SET_PROFILE } from '../store/types/action-types';

export function configureGuards(router: Router) {
  router.beforeEach(async (to: any, from, next) => {
    if (!to.matched.length) {
      next('/404');
      return;
    }

    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    const allowedRoles = to.meta?.allowedRoles;
    const allowedBackOfficeSubRoles = to.meta?.allowedBackOfficeSubRoles;
    const { isAuthenticated } = store.getters;
    const tokenExpired = sessionStorage.getItem('token-expired');

    if (!store.state.profile && !tokenExpired) {
      try {
        const profile = await userClient.me();
        store.dispatch(SET_PROFILE, profile);
      } catch (error) {
        if (requiresAuth) {
          if (error.status === 401) {
            store.dispatch(LOGOUT);
          }
        }
      }
    }

    if (requiresAuth && !isAuthenticated) {
      const token = store.state.token;

      if (token) {
        next();
      } else {
        next('/login');
      }
    } else if (
      requiresAuth &&
      isAuthenticated &&
      !(store.getters.checkUserRoles(allowedRoles) || store.getters.checkBackOfficeSubRoles(allowedBackOfficeSubRoles))
    ) {
      next(false);
    } else {
      next();
    }
  });

  /*
   * Il terzo argomento e la novita di vue-router 4: `afterEach` viene chiamato **anche quando la
   * navigazione non e andata a buon fine**, e `failure` dice che e successo. In vue-router 3 non
   * veniva chiamato affatto dopo un `next(false)`.
   *
   * Senza questa guardia il titolo si aggiorna su una pagina che non si e mai aperta: chiedendo
   * `/users` senza il ruolo `Administrator` la rotta viene rifiutata alla riga 45, la vista resta
   * quella di prima, ma la scheda del browser dice "Pulinet - Users". Chi guarda il titolo crede di
   * essere altrove.
   */
  router.afterEach(async (to, from, failure) => {
    if (failure) return;
    document.title = to.meta?.title;
  });
}
